import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import useCachedProductionList from '@src/adapters/hooks/production/useCachedProductionList';

interface Props {
  id: string;
}

function Production({ id }: Props) {
  const { getList } = useCachedProductionList();
  const [display, setDisplay] = useState('');
  useEffect(() => {
    getList(id).then((production) => {
      if (production && production.length === 1) {
        setDisplay(production[0].name);
      }
    });
  }, [getList, id]);
  return <Box>{display}</Box>;
}

export default Production;
